import React from 'react'
import { OneSymbolIcon } from '@yy/one-ui'
import withIcon from './hoc/withIcon'

const Filter: React.FC = () => {
  return <OneSymbolIcon icon="icon-Filter" />
}

Filter.displayName = 'Filter'

export default withIcon(Filter)
